module.exports = __webpack_public_path__ + "static/media/Magical Quest 3 - Nephew Colors hack.11446e5e.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/Magical Quest 3 - Nephew Colors hack.zip
// module id = 80
// module chunks = 0